import * as React from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import MenuIcon from "@mui/icons-material/Menu";
import { ClickAwayListener, IconButton, useMediaQuery } from "@mui/material";
import MenuListComposition from "./MenulistComposition";
import MDBox from "../MDBox";
import breakpoints from "../../assets/theme/base/breakpoints";
export default function MobileViewDrawer() {
  const [state, setState] = React.useState({
    left: false,
  });

  const isMediumScreenAndAbove = useMediaQuery(
    `(min-width:${breakpoints.values.md}px)`
  );

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: !open });
  };

  React.useEffect(() => {
    if (state.left && isMediumScreenAndAbove) {
      resetAllState();
    }
  }, [isMediumScreenAndAbove]);

  function resetAllState() {
    setState({ ...state, left: false });
  }

  const list = (anchor) => (
    <Box
      sx={{
        mt: 12.5,
        width: "55vw",
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <MenuListComposition View={"mobile"} />
    </Box>
  );

  return (
    <div>
      {["left"].map((anchor) => (
        <React.Fragment key={anchor}>
          <IconButton
            color="primary"
            aria-label="JMMMenu"
            onClick={toggleDrawer(anchor, state.left)}
          >
            <MenuIcon />
          </IconButton>

          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor] && !isMediumScreenAndAbove}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
            onDragStart={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
